import type { RailwayService, RailwaySession } from '@cli-types/next-adapter/railway.js'
import { outputTail } from '@cli-utils/process.js'
import { parseRailwayJson } from '@next-adapter/init/railway/runner/parse-railway-json.js'
import { runRailway } from '@next-adapter/init/railway/runner/run-railway.js'
import { firstDomainUrl } from './first-domain-url.js'
import { parseDomainList } from './parse-domain-list.js'

export async function ensureRailwayDomain(
  session: RailwaySession,
  cwd: string,
  service: RailwayService
): Promise<string | undefined> {
  const common = [
    '--service',
    service.name,
    '--environment',
    session.project.environmentName,
    '--json'
  ]
  const list = await runRailway(session.runner, ['domain', 'list', ...common], {
    cwd,
    mode: 'capture',
    env: session.env
  })
  if (!list.success) {
    throw new Error(
      outputTail(`${list.stdout}\n${list.stderr}`) ??
        `Could not list Railway domains for ${service.name}.`
    )
  }

  const domains = parseDomainList(parseRailwayJson<unknown>(list.stdout))
  if (!domains) {
    throw new Error(`Railway returned an invalid domain list response for ${service.name}.`)
  }
  const existing = domains[0]
  if (existing) return existing

  const create = await runRailway(session.runner, ['domain', ...common], {
    cwd,
    mode: 'capture',
    env: session.env
  })
  return create.success ? firstDomainUrl(parseRailwayJson<unknown>(create.stdout)) : undefined
}
